
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/grid-maker",
      function () {
        return require("private-next-pages/grid-maker/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/grid-maker"])
      });
    }
  